<ng-container *ngLet="activityTypes$ | async as activityTypes">

    <ml-ui-care-plan (menuItemClick)="onMenuItemClick($event)" (activityClick)="onActivityClick($event)"
        (actionClick)="onActionClick($event, activityTypes)"></ml-ui-care-plan>
        
</ng-container>